/* WI-29 — a colour swatch must not be distinguished by colour alone.
 *
 * WCAG 2.2 SC 1.4.1 (Level A) requires a *visible* alternative to colour, so a picker that shows
 * only image chips and reveals the name on hover does not pass. This appends a dot + name legend
 * under each colour picker, derived from what the chips already render (label text + the label's
 * inline background-image), so the colour mapping is not copied into a second place.
 *
 * Names are shortened with the measured rule from
 * operations/runs/wi29-swatch-short-names-20261017/package.json: drop parenthetical qualifiers,
 * drop the filler words Base / Bright / Highlight(s), abbreviate "with" to "w/", and keep the
 * secondary colour word (the browns are only distinguishable by it). The full name stays in the
 * list item's title, and the label's own text remains in the DOM for assistive technology.
 *
 * Deliberately dependency-free, idempotent, and silent when the picker is absent: the legend is an
 * addition to the rendered page, never a replacement for it.
 */
(function () {
  'use strict';

  var SHORT_MAX = 26;
  var LEGEND_CLASS = 'm-swatch-legend';

  function shortName(full) {
    var s = String(full || '').replace(/\s*\([^)]*\)/g, '').trim();
    s = s.replace(/\bBase\b/gi, ' ').replace(/\bBright\b/gi, ' ');
    s = s.replace(/\bHighlights?\b/gi, ' ');
    s = s.replace(/\swith\s/gi, ' w/ ');
    s = s.replace(/\s+/g, ' ').replace(/\s*w\s*\/\s*$/i, '').trim();
    if (s.length > SHORT_MAX) s = s.replace(/\bGolden\b/gi, 'Gold');
    return s;
  }

  function backgroundUrl(label) {
    var style = label.getAttribute('style') || '';
    var match = /url\(\s*(['"]?)([^)'"]+)\1\s*\)/.exec(style);
    return match ? match[2] : '';
  }

  function build(inner) {
    if (!inner || inner.querySelector('.' + LEGEND_CLASS)) return;
    // both picker shapes: image chips (product photos) and flat colour chips (background-color)
    var nodes = inner.querySelectorAll('.m-product-option--node[data-option-type="image"], .m-product-option--node[data-option-type="color"]');
    if (!nodes.length) return;
    var list = document.createElement('ul');
    list.className = LEGEND_CLASS;
    list.setAttribute('aria-label', 'Colour names');
    Array.prototype.forEach.call(nodes, function (node) {
      var label = node.querySelector('label');
      if (!label) return;
      var full = (label.textContent || '').trim();
      if (!full) return;
      var item = document.createElement('li');
      item.title = full;
      var dot = document.createElement('i');
      var url = backgroundUrl(label);
      if (url) {
        dot.style.backgroundImage = 'url("' + url.replace(/&width=\d+/, '&width=40') + '")';
      } else if (label.style && label.style.backgroundColor) {
        dot.style.backgroundColor = label.style.backgroundColor;
      }
      dot.setAttribute('aria-hidden', 'true');
      var text = document.createElement('span');
      text.textContent = shortName(full);
      item.appendChild(dot);
      item.appendChild(text);
      list.appendChild(item);
    });
    if (list.children.length) inner.appendChild(list);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('.m-product-option__inner'), build);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
